<template>
  <v-container class="create-project">
    
    <region v-if="step === 1" @changed="updateRegions"> </region>
    <project-name
      v-else-if="step === 2"
      v-bind:selected-regions="selectedRegions"
      @changed="updateName"
    ></project-name>

    <button
      :disabled="disabled"
      @click="next()"
      class="button__primary"
    >
      {{ buttonText }}
    </button>

  </v-container>
</template>

<script>
import RegionComponent from "@/components/RegionComponent";
import ProjectName from "@/components/ProjectName";
import { mapState } from "vuex";

export default {
  data() {
    return {
      step: 1,
      selectedRegions: null,
      projectName: null,
      countryCode: null,
      disabled: true,
      buttonText: this.$i18n.t('createProject.stepButton1'),
    };
  },

  components: {
    region: RegionComponent,
    "project-name": ProjectName,
  },

  computed: {
    ...mapState(["project"]),
  },

  methods: {
    next() {
      this.step++;
      if (this.step === 2) {
        this.buttonText = this.$i18n.t('createProject.stepButton2');
      } else if (this.step === 3) {
        this.$store.commit("newProject", {
          regions: this.selectedRegions,
          projectName: this.projectName,
        });
        this.$router.push("/projects/" + this.project.project_id + "/plant");
      }
    },

    updateRegions(regions) {
      this.selectedRegions = regions;
      if (this.selectedRegions.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },

    updateName(name, valid) {
      if (valid) {
        this.projectName = name;
        this.disabled = false;
      } else if (!valid) {
        this.disabled = true;
      }
    },
  },
  
};
</script>
